(function () {
  'use strict';
  if (!/^ar(?:-|$)/i.test(document.documentElement.lang)) return;
  var source = document.getElementById('FiAklaBookingTranslations');
  if (!source) return;
  var copy;
  try { copy = JSON.parse(source.textContent); } catch (_) { return; }
  var months = 'January|February|March|April|May|June|July|August|September|October|November|December'.split('|');
  var days = 'Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday'.split('|');
  var translatedMonths = copy.months.split('|');
  var translatedDays = copy.days.split('|');
  var labels = {'select date':copy.select_date,'service':copy.service,'select preferred time slot':copy.select_time,'reserve & go to cart':copy.reserve,'reserve a time':copy.reserve,'please select a time slot':copy.choose_time,'timezone: africa/cairo':copy.timezone,'2 hours':copy.two_hours};
  var attached = new WeakSet();
  function translated(value) {
    var clean = value.trim();
    if (labels[clean.toLowerCase()]) return value.replace(clean, labels[clean.toLowerCase()]);
    var result = value;
    months.forEach(function (month, i) { result = result.replace(new RegExp('\\b'+month+'\\b','gi'), translatedMonths[i]); });
    days.forEach(function (day, i) { result = result.replace(new RegExp('\\b'+day+'\\b','g'), translatedDays[i]); });
    if (/\d/.test(result)) result = result.replace(/\bAM\b/g,copy.am).replace(/\bPM\b/g,copy.pm);
    return result;
  }
  function attach(frame) {
    var doc;
    try { doc = frame.contentDocument; } catch (_) { return; }
    if (!doc || !doc.body || attached.has(doc)) return;
    attached.add(doc);
    doc.documentElement.lang = 'ar';
    var observer;
    function refresh() {
      if (observer) observer.disconnect();
      var walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        if (!node.parentElement || node.parentElement.closest('script,style,textarea')) continue;
        var value = translated(node.nodeValue);
        if (value !== node.nodeValue) node.nodeValue = value;
      }
      doc.querySelectorAll('.vc-weeks').forEach(function (week) {
        week.querySelectorAll('.vc-weekday').forEach(function (day,i) {
          var label = copy.weekdays.split('|')[i];
          if (label && day.textContent !== label) day.textContent = label;
        });
      });
      doc.querySelectorAll('[aria-label]').forEach(function (element) {
        var old = element.getAttribute('aria-label');
        var value = old === 'Clear selection' ? copy.clear_selection : old === 'Search for option' ? copy.search_option : translated(old);
        if (old !== value) element.setAttribute('aria-label',value);
      });
      doc.querySelectorAll('[title]').forEach(function (element) {
        var old = element.getAttribute('title');
        var value = old === 'Clear selection' ? copy.clear_selection : translated(old);
        if (old !== value) element.setAttribute('title',value);
      });
      if (observer) observer.observe(doc.body,{childList:true,subtree:true,characterData:true});
    }
    var style = doc.createElement('style');
    style.textContent = '.main-heading,.vc-title,.select-time-slot,.btn-book,.time-slot{font-family:Tahoma,Arial,sans-serif!important;letter-spacing:0!important}.main-heading,.select-time-slot{text-align:right}.vc-weekday{font:11px Tahoma,Arial,sans-serif!important}.time-slot{direction:rtl}.btn-book{white-space:normal!important}';
    doc.head.appendChild(style);
    observer = new MutationObserver(refresh);
    refresh();
    window.addEventListener('pagehide',function () { observer.disconnect(); },{once:true});
  }
  function scan() {
    var frame = document.getElementById('apntly-booking-iframe');
    if (!frame) return;
    if (!frame.dataset.fiLocaleBound) {
      frame.dataset.fiLocaleBound = 'true';
      frame.addEventListener('load',function () { attach(frame); });
    }
    attach(frame);
  }
  var frameObserver = new MutationObserver(scan);
  frameObserver.observe(document.body,{childList:true,subtree:true});
  scan();
  window.addEventListener('pagehide',function () { frameObserver.disconnect(); },{once:true});
})();
